import z from "zod";
import { createRefinableSchema } from "./utility-types/create-refinable-schema.js";
var EStorageProvider = /*#__PURE__*/ function(EStorageProvider) {
    EStorageProvider["Scaleway"] = "scaleway-s3";
    return EStorageProvider;
}(EStorageProvider || {});
var EStorageClass = /*#__PURE__*/ function(EStorageClass) {
    EStorageClass["Standard"] = "STANDARD";
    EStorageClass["Glacier"] = "GLACIER";
    return EStorageClass;
}(EStorageClass || {});
const createStorageSchema = createRefinableSchema({
    schema: (context)=>z.object({
            key: z.string(),
            provider: z.enum(EStorageProvider),
            bucket: z.string(),
            class: z.enum(EStorageClass),
            name: z.string(),
            contentLength: z.number(),
            contentType: z.string().regex(/^[\w.-]+\/[\w.+-]+$/),
            uploadDate: z.coerce.date(),
            hidden: z.boolean(),
            downloadUrl: z.string().optional(),
            deleted: z.boolean()
        })
});
var EStorageImageType = /*#__PURE__*/ function(EStorageImageType) {
    EStorageImageType["Gif"] = "gif";
    EStorageImageType["Jpeg"] = "jpeg";
    EStorageImageType["Png"] = "png";
    EStorageImageType["Svg"] = "svg";
    EStorageImageType["Webp"] = "webp";
    return EStorageImageType;
}(EStorageImageType || {});
const STORAGE_FILE_TYPES_IMAGE = [
    "gif",
    "jpeg",
    "png",
    "webp",
    "svg"
];
Object.freeze(STORAGE_FILE_TYPES_IMAGE);
export { createStorageSchema, EStorageClass, EStorageImageType, EStorageProvider, STORAGE_FILE_TYPES_IMAGE };
